import styled, {css} from "styled-components";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";

interface IUserMenuSectionBoxProps {
    noVerticalPadding?: boolean;
    noHorizontalPadding?: boolean;
}

const UserMenuSectionDefaultBox = styled.div<IUserMenuSectionBoxProps>`
    margin-top: 1rem;
    color: ${({theme}) => theme.colors.text};
    background: ${({theme}) => theme.colors.background};
    border-radius: 5px;
    
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {  
        margin-top: 1rem;
    }

    ${({noHorizontalPadding}) => noHorizontalPadding ? '' : css`
        padding-left: 1.6rem;
        padding-right: 1.6rem;
    `}
    ${({noVerticalPadding}) => noVerticalPadding ? '' : css`
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    `}
`;

const UserMenuSectionCasino777Box = styled(UserMenuSectionDefaultBox)`
    background-color: ${({theme}) => theme.colors.logoBackground };
`;

export const UserMenuSectionBox = styledByTheme(UserMenuSectionDefaultBox).forCasino777(UserMenuSectionCasino777Box).apply();
